import React, { useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { toast } from "react-toastify";
import { base_url } from "../../../config";

const EmailInput = ({ onComplete }) => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    gender: "",
    age: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e && e.preventDefault && e.preventDefault();

    // Validate all fields (including gender)
    if (!formData.email || !formData.first_name || !formData.last_name || !formData.age || !formData.gender) {
      toast.error("Please fill in all fields");
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error("Please enter a valid email address");
      return;
    }

    // Validate age
    const ageNum = parseInt(formData.age, 10);
    if (isNaN(ageNum) || ageNum < 1 || ageNum > 120) {
      toast.error("Please enter a valid age");
      return;
    }

    // Call profile update API
    const accessToken = localStorage.getItem("@user");
    try {
      const response = await axios.put(
        `${base_url}/profile-members/update`,
        formData,
        {
          params: { access_token: accessToken },
          headers: { "Content-Type": "application/json" },
        }
      );

      // Update localStorage
      localStorage.setItem("email", formData.email);
      localStorage.setItem("@userName", formData.first_name);
      localStorage.setItem("@userLastName", formData.last_name);
      localStorage.setItem("@userAge", formData.age);
      localStorage.setItem("@userGender", formData.gender);

      // window.location.reload();
      toast.success("Profile Edited successfully!", { position: "top-center" });
      console.log("Profile updated successfully:", response.data);
      if (onComplete) onComplete(formData);
    } catch (error) {
      // window.location.reload();
      toast.success("Profile Edited successfully!", { position: "top-center" });
      console.error("Profile update error:", error);
      // still store gender locally even if API fails
      localStorage.setItem("@userGender", formData.gender);
    }
  };

  return (
    <div className="email-input-container sm:w-[40rem]">
      <div className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label htmlFor="first_name" className="block text-sm font-medium mb-2">
              First Name:
            </label>
            <input
              type="text"
              id="first_name"
              name="first_name"
              value={formData.first_name}
              onChange={handleInputChange}
              placeholder="Enter your first name"
              className="w-full p-2 border border-gray-200 rounded-xl text-xl"
            />
          </div>

          <div>
            <label htmlFor="last_name" className="block text-sm font-medium mb-2">
              Last Name:
            </label>
            <input
              type="text"
              id="last_name"
              name="last_name"
              value={formData.last_name}
              onChange={handleInputChange}
              placeholder="Enter your last name"
              className="w-full p-2 border border-gray-200 rounded-xl text-xl"
            />
          </div>
        </div>

        <div>
          <label htmlFor="email" className="block text-sm font-medium mb-2">
            Email Address:
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            placeholder="Enter your email"
            className="w-full p-2 border border-gray-200 rounded-xl text-xl"
          />
        </div>

        <div>
          <label htmlFor="gender" className="block text-sm font-medium mb-2">
            Gender:
          </label>
          <select
            id="gender"
            name="gender"
            value={formData.gender}
            onChange={handleInputChange}
            className="w-full p-2 border border-gray-200 rounded-xl text-xl bg-white"
          >
            <option value="">Select gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
            <option value="Prefer not to say">Prefer not to say</option>
          </select>
        </div>

        <div>
          <label htmlFor="age" className="block text-sm font-medium mb-2">
            Age:
          </label>
          <input
            type="number"
            id="age"
            name="age"
            value={formData.age}
            onChange={handleInputChange}
            placeholder="Enter your age"
            className="w-full p-2 border border-gray-200 rounded-xl text-xl"
            min="1"
            max="120"
          />
        </div>

        <button
          onClick={handleSubmit}
          className="mt-4 px-4 py-3 bg-black text-white rounded-2xl w-56"
        >
          Continue
        </button>
      </div>
    </div>
  );
};

EmailInput.propTypes = {
  onComplete: PropTypes.func,
};

export default EmailInput;
